<script>
import simplebar from "simplebar-vue";
import Layout from "@/pages/home/layout";

import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { chatData, chatMessagesData } from "./data";

import { required } from "vuelidate/lib/validators";
import {messageModel} from "@/models/messageModel";
import {questionModel} from "@/models/questionModel";
import LetterCube from "@/components/LetterCube";

/**
 * Chat Component
 */
export default {
  page: {
    title: "Chat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
        LetterCube
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
  },
  data() {
    return {
      chatData: chatData,
      chatMessagesData: chatMessagesData,

      submitted: false,
      form: {
        message: "",
      },
      username: "Hệ thống chatbot thử nghiệm (Phạm vi 155 thủ tục)",
      modelMessage : messageModel.baseJson(),
      modelQuestion : questionModel.baseJson("00"),
      code : "0000",
      currentDate :  new Date(),
      time : null ,
      urlFile:`${process.env.VUE_APP_API_URL}files/view/65fa5c80b957a5f627ad2ed5`,
    };
  },
  validations: {
    form: {
      message: {
        required,
      },
    },
  },
  methods: {
    /**
     * Get the name of user
     */
    chatUsername(name) {
      // this.username = name;
      // this.usermessage = "Hello";
      // this.chatMessagesData = [];
      // const currentDate = new Date();
      // this.chatMessagesData.push({
      //   name: this.username,
      //   message: this.usermessage,
      //   time: currentDate.getHours() + ":" + currentDate.getMinutes(),
      // });
    },
    async formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const message = this.form.message;
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        },{
          default: this.$createElement(LetterCube),
        })
        // Lấy thời gian hiện tại
        const currentDate = new Date();
        let hours = currentDate.getHours();
        let minutes = currentDate.getMinutes();

        // Định dạng thời gian
        const time = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

        this.chatMessagesData.push({
          align: "right",
          name: this.modelMessage.name,
          message: message,
          time: time
        });

        this.modelQuestion.content = message;
        this.modelQuestion.CodeQuestion = this.code;
        this.form.message = "";
        await this.$store.dispatch("messageStore/create" , this.modelQuestion).then((res) => {
          if (res.code == 0) {

            const currentTime = new Date();
            let hours = currentTime.getHours();
            let minutes = currentTime.getMinutes();
            const time = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
           // console.log("HOI: ", this.modelMessage);
            this.chatMessagesData.push({
              align: "",
              name: "CHATBOT",
              message: res.data.content,
              time: time
            });
          }
        })
        loader.hide();
        this.handleScroll();
      }
      this.submitted = false;
      this.form = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  created() {
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
      console.log("CURRENT USER AUTH  created : ", this.currentUserAuth)
    }
     this.code = Math.floor(Math.random()* 10000).toString()
         + this.currentDate.getFullYear().toString()
         + this.currentDate.getMonth().toString()
         + this.currentDate.getDate().toString()
         + this.currentDate.getHours().toString()
         + this.currentDate.getSeconds().toString() ;

  },

  mounted() {
    var container1 = document.querySelector(
      "#chat-list .simplebar-content-wrapper"
    );
    container1.scrollTo({ top: 500, behavior: "smooth" });

    var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" });
  },
};
</script>

<template>
  <Layout>
    <PageHeader />
    <div class="action chat container">
        <div class="row">
          <div class="col-sm-12 col-md-4 mb-3">
            <div class="bg-dvc">
              <a target="_blank" href="https://dichvucong.gov.vn/p/home/dvc-trang-chu.html">
                <img src="@/assets/images/dvc.jpg" alt="" width="100%" height="100px" style="border-radius: 5px;">
              </a>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 mb-3">
              <a target="_blank" href="https://dichvucong.dongthap.gov.vn/?gidzl=uYzHC9nVtKVcDrCtbqZRGEmyNJwAIz4Ty6yFQ8WHqKgZPbautHBI6APb23_Q6jGVfcLQF6H8Hhz6c5hOJm">
                <img src="@/assets/images/tthc.png" alt="" width="100%" height="100px" style="border-radius: 5px;">
              </a>
          </div>
          <div class="col-sm-12 col-md-4 md-3">
            <a target="_blank" href="https://dongthap.gov.vn/">
                <img src="@/assets/images/dongthap.jpg" alt="" width="100%" height="100px" style="border-radius: 5px;">
              </a>
          </div>
        </div>
      </div>
    <div class="d-lg-flex container">
      <div class="w-100 user-chat">
        <div class="card-chat">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-10 col-10">
                <h5 class="mb-1" style="font-weight: bold;">{{ username }}</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Đang hoạt động
                </p>
              </div>
              <div class="col-md-2 col-2">
                <div style="text-align: right;">
                  <button class="btn btn-md btn-primary">
                    <a 
                      :href="`${urlFile}`"
                      class="text-white fw-medium d-flex justify-content-center align-items-center" 
                    >
                      Tải DS THỦ TỤC
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="chat-users">
            <div class="chat-conversation p-3">
              <simplebar
                style="max-height: 470px"
                id="containerElement"
                ref="current"
              >
                <ul class="list-unstyled">
                  <li>
                    <div class="chat-day-title">
                      <span class="title">Hôm nay</span>
                    </div>
                  </li>
                  <li
                    v-for="data of chatMessagesData"
                    :key="data.message"
                    :class="{ right: `${data.align}` === 'right' }"
                  >
                    <div class="conversation-list">
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <p>{{ data.message }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.time }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative" style="border: 0.5px solid #204b03; border-radius: 5px;">
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                    />
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md bg-color"
                    style="border: none;"
                  >
                    <span class="d-none d-sm-inline-block me-2">Gửi</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>

.bg-dvc{
  height: 100%;
}

.card-chat{
  background-color: #fff;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  margin-bottom: 20px;
}

.action{
  text-align: center;
}

.action button:hover{
  background-color: #204b03f3;
}

.action button a{
  color: #fff;
}

.conversation-name{
  color: #204b03 !important;
}

</style>
<style scoped>
.chat-users .chat-conversation{
  min-height: 300px !important;
}
</style>
